import { ButtonERP } from "@finanedi.es/storybook"
import {
  faArrowLeft,
  faArrowRotateRight,
  faFileExport,
} from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { DeclaracionModelo303DtoProps } from "api/DTOs/DeclaracionModelo303Dto"
import { GetDatosDeclaracionModelo303DtoProps } from "api/DTOs/GetDatosDeclaracionModelo303Dto"
import { useDeclaracion303 } from "api/DeclaracionModelo.hook"
import { MODELO_IMPUESTO } from "api/Types/ModeloImpuesto"
import { PeriodoDeclaracionModeloEnumType } from "api/Types/PeriodoDeclaracionModeloEnum"
import { useUsuarioEmpresaActiva } from "api/Usuario.hook"
import notification from "common/utils/notification"
import { TFunction } from "i18next"
import { useState } from "react"
import { useForm } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { useHistory, useLocation } from "react-router-dom"
import InformacionAdicionalModelo303 from "../InformacionAdicionalModelo303/InformacionAdicionalModelo303"
import { ModalPresentarModelo } from "../ModalPresentarModelo/ModalPresentarModelo"
import ResultadoModelo303 from "../ResultadoModelo303/ResultadoModelo303"
import DevengoModelo303 from "./DevengoModelo303/DevengoModelo303"
import IdentificacionModelo303 from "./IdentificacionModelo303"
import LiquidacionModelo303 from "./LiquidacionModelo303/LiquidacionModelo303"
import { getPeriodoDeclaracion } from "./constants"

const mapRespToDto = (
  resp: GetDatosDeclaracionModelo303DtoProps,
  ejercicio?: string,
  periodo?: PeriodoDeclaracionModeloEnumType | null,
  razonSocial?: string | null,
  nif?: string | null
): DeclaracionModelo303DtoProps => {
  return {
    dp30300: {
      ejercicioDevengo: ejercicio,
      periodo,
    },
    dp30301: {
      casilla01: resp.casilla01 || 0,
      casilla03: resp.casilla03 || 0,
      casilla04: resp.casilla04 || 0,
      casilla06: resp.casilla06 || 0,
      casilla07: resp.casilla07 || 0,
      casilla09: resp.casilla09 || 0,
      casilla10: resp.casilla10 || 0,
      casilla11: resp.casilla11 || 0,
      casilla12: resp.casilla12 || 0,
      casilla13: resp.casilla13 || 0,
      casilla14: 0,
      casilla15: 0,
      casilla16: 0,
      casilla18: 0,
      casilla19: 0,
      casilla21: 0,
      casilla22: 0,
      casilla23: 0,
      casilla24: 0,
      casilla25: 0,
      casilla26: 0,
      casilla28: resp.casilla28 || 0,
      casilla29: resp.casilla29 || 0,
      casilla30: 0,
      casilla31: 0,
      casilla32: 0,
      casilla33: 0,
      casilla34: 0,
      casilla35: 0,
      casilla36: resp.casilla36 || 0,
      casilla37: resp.casilla37 || 0,
      casilla38: resp.casilla38 || 0,
      casilla39: resp.casilla39 || 0,
      casilla40: 0,
      casilla41: 0,
      casilla42: 0,
      casilla43: 0,
      casilla44: 0,
      casilla150: 0,
      casilla152: 0,
      casilla153: 0,
      casilla155: 0,
      casilla156: 0,
      casilla158: 0,
      casilla165: 0,
      casilla167: 0,
      casilla168: 0,
      casilla170: 0,
      tipoDeclaracion: null,
      nif,
      razonSocial,
      tributacionForal: false,
      devolucionMensual: false,
      regimenSimple: false,
      autoliquidacionConjunta: false,
      criterioDeCaja: false,
      operacionesCriterioDeCaja: false,
      opcionProrrataEspecial: false,
      revocacionProrrataEspecial: false,
      concursoAcreedores: false,
      fechaConcursoAcreedores: null,
      tipoAutoliquidacionConcursoAcreedores: null,
      voluntarioSii: false,
      exoneradoDeclaracion: null,
      volumenOperacionDistintoCero: false,
      ejercicio,
      periodo,
    },
    dp30303: {
      autoliquidacionRectificativa: false,
      casilla59: resp.casilla59 || 0,
      casilla60: 0,
      casilla62: 0,
      casilla63: 0,
      casilla65: 100,
      casilla66: 0,
      casilla68: 0,
      casilla70: 0,
      casilla74: 0,
      casilla75: 0,
      casilla76: 0,
      casilla77: 0,
      casilla78: 0,
      casilla108: 0,
      casilla109: 0,
      casilla110: 0,
      casilla111: 0,
      casilla120: resp.casilla120 || 0,
      casilla122: resp.casilla122 || 0,
      casilla123: 0,
      casilla124: 0,
      motivoRectificacionDiscrepancia: false,
      motivoRectificacionRectificaciones: false,
      numeroJustificante: null,
      rectificativaBajaDomiciliacionEfectuada: false,
      sinActividad: false,
    },
    dp303Did: {
      ciudad: null,
      codigoPais: null,
      direccionBanco: null,
      iban: null,
      marcaSepa: null,
      nombreBanco: null,
      swiftBic: null,
    },
    ejercicioDevengo: ejercicio,
    periodo,
  }
}

const SECCIONES_TYPES = {
  IDENTIFICACION: 1,
  DEVENGO: 2,
  LIQUIDACION: 3,
  INFORMACION_ADICIONAL: 4,
  RESULTADO: 5,
}

const SECCIONES = (t: TFunction) => [
  {
    id: SECCIONES_TYPES.IDENTIFICACION,
    label: `${SECCIONES_TYPES.IDENTIFICACION} - ${t(
      "taxSummary.declaracion.identificacion"
    )}`,
  },
  {
    id: SECCIONES_TYPES.DEVENGO,
    label: `${SECCIONES_TYPES.DEVENGO} - ${t(
      "taxSummary.declaracion.devengo"
    )}`,
  },
  {
    id: SECCIONES_TYPES.LIQUIDACION,
    label: `${SECCIONES_TYPES.LIQUIDACION} - ${t(
      "taxSummary.declaracion.liquidacion"
    )}`,
  },
  {
    id: SECCIONES_TYPES.INFORMACION_ADICIONAL,
    label: `${SECCIONES_TYPES.INFORMACION_ADICIONAL} - ${t(
      "taxSummary.declaracion.informacionAdicional"
    )}`,
  },
  {
    id: SECCIONES_TYPES.RESULTADO,
    label: `${SECCIONES_TYPES.RESULTADO} - ${t(
      "taxSummary.declaracion.resultado"
    )}`,
  },
]

const DeclaracionModelo303 = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const [tabSelected, setSelectedTab] = useState(SECCIONES_TYPES.IDENTIFICACION)
  const [showModalPresentar, setShowModalPresentar] = useState<boolean>(false)
  const [isUpdating, setIsUpdating] = useState<boolean>(false)
  const {
    activeCompany: { razonSocial, nif },
  } = useUsuarioEmpresaActiva()

  const { state } = useLocation()
  const periodo = getPeriodoDeclaracion(state?.periodo)
  const { declaracion303Data, declaracion303DataRefetch } = useDeclaracion303({
    queryParams: {
      Anyo: Number(state?.year),
      PeriodoDeclaracion: periodo.value,
    },
    mapRespToDto,
    razonSocial,
    nif,
    periodo,
    year: state?.year,
  })

  const { setValue, watch, reset } = useForm<DeclaracionModelo303DtoProps>({
    values: declaracion303Data,
    mode: "onChange",
    reValidateMode: "onChange",
  })

  const handleUpdateClick = async () => {
    setIsUpdating(true)
    try {
      const { data: updatedData } = await declaracion303DataRefetch()
      if (updatedData) {
        reset(updatedData)
        notification.success({
          body: `${t("taxSummary.declaracion.successNotification")}`,
        })
        setIsUpdating(false)
      }
    } catch (error) {
      setIsUpdating(false)
      notification.errorServidor()
    }
  }

  return (
    <div className='tw-w-full tw-h-full tw-overflow-hidden tw-bg-white'>
      <div className='tw-h-fit tw-p-3 tw-w-full tw-bg-white tw-shadow'>
        <div className='tw-h-11 tw-flex tw-flex-row tw-w-full tw-items-center tw-justify-between'>
          <div className='tw-flex tw-flex-row tw-gap-4 tw-items-center tw-h-full'>
            <ButtonERP
              customize={{
                size: "md",
                type: "transparent",
              }}
              onClick={() => history.goBack()}
              icon={<FontAwesomeIcon icon={faArrowLeft} />}
            />
            <span className='tw-rounded tw-h-fit tw-py-1 tw-px-2 tw-text-sm tw-text-white tw-bg-[#B7CB8C]'>
              {MODELO_IMPUESTO.MODELO_303}
            </span>
            <span className='tw-text-base tw-font-medium tw-h-fit'>
              {t("taxSummary.tableTitle")} - {periodo.label} {state?.year}
            </span>
          </div>
          <div className='tw-flex tw-flex-row tw-gap-3'>
            <ButtonERP
              customize={{ size: "md", type: "transparent" }}
              label={`${t("taxSummary.declaracion.updateButton")}`}
              loading={isUpdating}
              disabled={isUpdating}
              icon={<FontAwesomeIcon icon={faArrowRotateRight} />}
              onClick={() => {
                handleUpdateClick()
              }}
            />
            <ButtonERP
              customize={{
                size: "md",
                type: "primary",
              }}
              onClick={() => setShowModalPresentar(!showModalPresentar)}
              icon={<FontAwesomeIcon icon={faFileExport} />}
              label={`${t("taxSummary.declaracion.presentar")}`}
            />
          </div>
        </div>
      </div>
      <div className='tw-w-full tw-h-[calc(100%-68px)] tw-flex tw-flex-row'>
        <div className='tw-w-1/5 tw-p-6 tw-flex tw-flex-col tw-items-start tw-border-r tw-border-neutral-25'>
          <p className='tw-font-medium tw-text-base'>
            {t("taxSummary.declaracion.secciones")}
          </p>
          <div className='tw-flex tw-flex-col tw-items-start tw-mt-4 tw-w-full tw-gap-1 tw-text-left'>
            {SECCIONES(t).map(({ id, label }) => (
              <p
                key={id}
                className={`tw-h-10 tw-w-full tw-px-4 hover:tw-bg-neutral-25 ${
                  tabSelected === id ? "tw-bg-neutral-25" : ""
                } tw-flex tw-items-center tw-cursor-pointer tw-rounded tw-truncate tw-text-ellipsis`}
                onClick={() => setSelectedTab(id)}
              >
                {label}
              </p>
            ))}
          </div>
        </div>
        <div className='tw-w-4/5 tw-flex tw-flex-col tw-items-start tw-overflow-y-auto'>
          <div className='tw-w-full tw-text-base tw-font-medium tw-flex tw-items-center tw-justify-start tw-px-6 tw-py-4'>
            {SECCIONES(t).find((s) => s.id === tabSelected)?.label}
          </div>
          {tabSelected === SECCIONES_TYPES.IDENTIFICACION && (
            <IdentificacionModelo303
              setValue={setValue}
              watch={watch}
            />
          )}
          {tabSelected === SECCIONES_TYPES.DEVENGO && (
            <DevengoModelo303
              periodo={periodo}
              ejercicio={state?.year}
            />
          )}
          {tabSelected === SECCIONES_TYPES.LIQUIDACION && (
            <LiquidacionModelo303
              setValue={setValue}
              watch={watch}
            />
          )}
          {tabSelected === SECCIONES_TYPES.INFORMACION_ADICIONAL && (
            <InformacionAdicionalModelo303
              setValue={setValue}
              watch={watch}
            />
          )}
          {tabSelected === SECCIONES_TYPES.RESULTADO && (
            <ResultadoModelo303
              setValue={setValue}
              watch={watch}
            />
          )}
        </div>
      </div>
      <ModalPresentarModelo
        showModalPresentar={showModalPresentar}
        setShowModalPresentar={setShowModalPresentar}
        watch={watch}
        setValue={setValue}
      />
    </div>
  )
}

export default DeclaracionModelo303
